// @flow
import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/app';

const root = document.querySelector('#client-app');
if (root !== null) {
  ReactDOM.render(<App />, root);
} else {
  throw Error('The provided root is not in the document');
}
